import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-xl md:text-3xl font-semibold text-foreground-900">
              精选文章
            </h2>
            <p className="mt-2 text-sm text-foreground-600">编辑团队的用心推荐</p>
          </div>
          <Link
            to="/category/luxury-flights"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 text-xs rounded-full bg-accent-100 text-accent-800">
                  {article.categoryName}
                </span>
                <h3 className="mt-2 text-sm md:text-base font-medium text-foreground-900 leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-600 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.publishedAt}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime} 分钟
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <Link
          to="/category/luxury-flights"
          className="sm:hidden mt-4 inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}